import React from 'react';
import { renderMarkdownToReact } from '../../../components/UI/MarkdownText/MarkdownText';

const GameHeader = ({ headline, introText }) => {
    return (
        <header className="text-center mb-3 px-2 w-100">
            <h1 className="h4 text-primary fw-bold mb-2" style={{ letterSpacing: '-0.144px', lineHeight: '1.3' }}>
                {headline || 'Robin Gut pflanzt Zukunft'}
            </h1>
            <p className="text-secondary mx-auto mb-0" style={{ fontSize: '0.9rem', maxWidth: '560px', letterSpacing: '0.072px' }}>
                {renderMarkdownToReact(introText || 'Finde alle Paare, lerne interessante Fakten und sichere eine Gewinn-Chance!')}
            </p>
        </header>
    );
};

export default GameHeader;
